import { Box, Hidden } from "@mui/material";
import styles from "./Carousel.module.css";
import { useEffect, useState } from "react";
import Slide from "@mui/material/Slide";
import Stack from "@mui/material/Stack";
import BottomBarImage from "../../images/bottom-bar.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";

interface SliderButtonsProps {
    currentPage: number,
    setCurrentPage : any,
    noOfCards: number
}

export const SliderButtons = ({currentPage, setCurrentPage, noOfCards}: SliderButtonsProps) => {
    const indices = Array.from({ length: noOfCards }, (_, index) => index);
    const handleClick = (index: number) => {
        setCurrentPage(index);
    }
    return (
        <Box className={styles.iconContainer}
        >
            {
                indices.map((index) => 
                    <FontAwesomeIcon 
                        key={`carousel-button-${index}`}
                        icon={faCircle} 
                        className={index === currentPage ? styles.iconSelected : styles.iconDeSelected}
                        onClick={() => handleClick(index)}
                        data-testid="carousel-buttons"
                        size="lg"
                    />
                )
            }
        </Box>
    )
}

interface CarouselProps {
    cards: React.ReactElement[]
}

export const Carousel = ({cards}: CarouselProps) => {
    const noOfCards = cards.length;
    const refreshIntervalInMiliSeconds = 10000;
    const slidingFadeOutInMiliSeconds = 700;
    const [currentPage, setCurrentPage] = useState(0);
    
    const handleNextPage = () => {
        setCurrentPage((prevPage) => (prevPage + 1) % noOfCards);
    };
    useEffect(() => {
        const intervalId = setInterval(() => {
            handleNextPage();
        }, refreshIntervalInMiliSeconds);
        return () => clearInterval(intervalId);
        // eslint-disable-next-line
    }, []);

    return (
        <Box className={styles.container} data-testid="carousel">
            <SliderButtons currentPage={currentPage} setCurrentPage={setCurrentPage} noOfCards={noOfCards}/>
            <Box className={styles.fitFullArea}>
                {cards.map((card, index) => (
                    <Box
                        data-testid="carousel-card"
                        key={`carousel-card-${index}`}
                        sx={{
                            display: currentPage === index ? "block" : "none",
                        }}
                        className={styles.fitFullArea}
                    >
                        <Slide direction={"left"} in={currentPage === index} timeout={slidingFadeOutInMiliSeconds}>
                            <Stack
                                spacing={2}
                                direction="row"
                                className={styles.fitFullArea}
                            >
                                {
                                    cards.slice(index,++index)
                                }
                            </Stack>
                        </Slide>
                    </Box>
                ))}
                <Hidden smDown>
                    <img src={BottomBarImage} alt="Bottom Bar Icon" className={styles.bottomBarImage} data-testid="carousel-bottom-image" />
                </Hidden>
            </Box>
        </Box>
    )
}